import * as ActionTypes from './actionTypes';
import apiActionCreator from '../../common/service/api/actionCreator';
import {buildErrorMessage} from '../../common/util/errorUtils';

export const getComboByChasis = (chassis) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/combos-vehicles/${chassis}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_VEHICLE_COMBO_BY_CHASIS,
        ActionTypes.FETCHED_VEHICLE_COMBO_BY_CHASIS,
        [ActionTypes.FETCHED_VEHICLE_COMBO_BY_CHASIS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const getCombosBySearchParam = (search) => (dispatch) => {
  return dispatch(
    apiActionCreator({
      'endpoint': `/combos-vehicles/vehicles?search=${search}`,
      'authenticated': true,
      'types': [
        ActionTypes.FETCHING_VEHICLE_COMBOS,
        ActionTypes.FETCHED_VEHICLE_COMBOS,
        [ActionTypes.FETCHED_VEHICLE_COMBOS_FAILED, (error) => buildErrorMessage(error)],
      ],
      'microservice': 'part',
      'method': 'GET',
    })
  );
};

export const clearCombosByChassis = () => ({
  'type': ActionTypes.CLEAR_VEHICLES_COMBOS,
});

export const clearCombosBySearchParam = () => ({
  'type': ActionTypes.CLEAR_VEHICLE_COMBO_BY_CHASIS,
});
